var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPerson(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icons /  Webapp UI",
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0013 2.29169C8.50553 2.29169 7.29297 3.50425 7.29297 5.00002C7.29297 6.49579 8.50553 7.70835 10.0013 7.70835C11.4971 7.70835 12.7096 6.49579 12.7096 5.00002C12.7096 3.50425 11.4971 2.29169 10.0013 2.29169ZM6.04297 5.00002C6.04297 2.81389 7.81517 1.04169 10.0013 1.04169C12.1874 1.04169 13.9596 2.81389 13.9596 5.00002C13.9596 7.18615 12.1874 8.95835 10.0013 8.95835C7.81517 8.95835 6.04297 7.18615 6.04297 5.00002Z",
    fill: "#1C1B1E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.875 18.3333C1.875 13.846 5.5127 10.2083 10 10.2083C14.4873 10.2083 18.125 13.846 18.125 18.3333C18.125 18.6785 17.8452 18.9583 17.5 18.9583C17.1548 18.9583 16.875 18.6785 16.875 18.3333C16.875 14.5364 13.7969 11.4583 10 11.4583C6.20305 11.4583 3.125 14.5364 3.125 18.3333C3.125 18.6785 2.84518 18.9583 2.5 18.9583C2.15482 18.9583 1.875 18.6785 1.875 18.3333Z",
    fill: "#1C1B1E"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerson);
export default __webpack_public_path__ + "static/media/person.f1ede81c22ce3c7a10b80eeec7bf72b9.svg";
export { ForwardRef as ReactComponent };